import $ from "jquery";
import __ajax from "../../utils/submit-form/__ajax";

const forgetPassword = () => {
  const init = () => {
    forgetPasswordTab();
    inputCode();
    savePassword();
  };

  // timer handler
  const timer = 300000; //in miliseconds
  let intervalId;
  const el = {
    timer: ".js-Timer",
    timerReset: ".js-TimerReset",
  };

  const updateTimerDisplay = (remainingTime) => {
    const minutes = Math.floor(remainingTime / 60000);
    const seconds = ((remainingTime % 60000) / 1000).toFixed(0);
    $(el.timer).text(minutes + ":" + (seconds < 10 ? "0" : "") + seconds);
  };

  const countdown = (duration) => {
    let remainingTime = duration;
    updateTimerDisplay(remainingTime);

    intervalId = setInterval(() => {
      remainingTime -= 1000; // Decrease by 1 second (1000 milliseconds)
      updateTimerDisplay(remainingTime);
      $(el.timerReset).addClass('disabled')

      if (remainingTime <= 0) {
        clearInterval(intervalId); // Stop the countdown when time is up
        $(el.timerReset).removeClass('disabled')
      }
    }, 1000); // Update the timer every second (1000 milliseconds)
  };

  const forgetPasswordTab = () => {
    const el = {
      button: ".js-NextButton",
      form: ".js-FormResetPasswordStep1",
      tab1: "#forget-password-step-1",
      tab2: "#forget-password-step-2",
      tab3: "#forget-password-step-3",
      details: ".js-DetailsTab",
    };

    if ($(el.details).length === 0) return;

    // pass data object to popup
    $(document).on("submit", el.form, function (e) {
      e.preventDefault();
      $('body').addClass('mi-loading')
      const email = $(this).find('#user_login').val()

      sendOTP($(this), email)
      $('#popup-notification-sent_success').addClass('active');
      clearInterval(intervalId);
      countdown(timer);
      $('body').removeClass('mi-loading')
    });

  };

  const sendOTP = (form, email) => {
    __ajax(form, {
      email: email
    }).then(() => {
      $(".js-DetailsTab").attr("open", false);
      $(`#forget-password-step-2`).attr("open", true);
      $('.email_step2').val(email);
      $('#popup-notification-sent_success').addClass('active');
    }).catch(() => {
      $('#popup-notification-email_not_found').addClass('active');
    })

  }


  const inputCode = () => {
    const el = {
      input: ".js-NumberInput",
      container: "#forget-password-step-2",
      timer: ".js-Timer",
      timerReset: ".js-TimerReset",
      form: '.js-FormResetPasswordStep2'
    };

    if ($(el.container).length === 0) return;
    $(() => {
      const charLimit = 1;
      // Input field keydown event
      $(document).on("keydown", el.input, function (e) {
        const keys = [
          8, 9, 19, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46, 144, 145,
        ];

        if ((e.ctrlKey || e.metaKey) && e.which === 86) {
          return true;
        } else if (e.which == 8 && this.value.length == 0) {
          $(this).prev(el.input).trigger("focus");
        } else if ($.inArray(e.which, keys) >= 0) {
          return true;
        } else if (this.value.length >= charLimit) {
          $(this).next(el.input).trigger("focus");
          return false;
        } else if (e.shiftKey || e.which <= 48 || e.which >= 58) {
          return false;
        }
      });

      // Input field keyup event
      $(document).on("keyup", el.input, function () {
        if (this.value.length >= charLimit) {
          $(this).next(el.input).trigger("focus");
          return false;
        }
      });

      $(el.input).on('paste', function (p) {
        let dataLength = p.originalEvent.clipboardData.getData('text').length;

        for (let i = 1; i <= dataLength; i++) {
          $("input[tabindex='" + i + "']").val(p.originalEvent.clipboardData.getData('text')[i - 1]);

          if (this.value.length >= this.maxLength) {
            $("input[tabindex='" + i + "']").trigger("focus");
          }
        }
      });

      // pass data object to popup
      $(document).on("submit", el.form, function (e) {
        e.preventDefault();
        $('body').addClass('mi-loading')
        const button = $(this).find('button[type="submit"]')
        const email = $(this).find('.email_step2').val()
        const key1 = $(this).find('#user_login1').val()
        const key2 = $(this).find('#user_login2').val()
        const key3 = $(this).find('#user_login3').val()
        const key4 = $(this).find('#user_login4').val()
        const key5 = $(this).find('#user_login5').val()
        const key = key1 + key2 + key3 + key4 + key5;
        __ajax($(this), {
          email: email,
          key: key
        }).then(() => {

          $(el.container).attr("open", false);

          const nextTab = button.data("next");
          $(`#forget-password-step-${nextTab}`).attr("open", true);
        }).catch((err) => {
          $('#popup-notification-key_not_match').addClass('active');
          console.error(err)
        })

        $('body').removeClass('mi-loading')
      });

      $(document).on("click", el.timerReset, function () {
        // Clear any existing intervals
        const form = $('.js-FormResetPasswordStep1')
        const email = $('#user_login').val()

        sendOTP(form, email)
        clearInterval(intervalId);
        countdown(timer);
      });
    });
  };

  const savePassword = () => {
    const el = {
      form3: ".js-FormResetPasswordStep3",
      tab3: "#forget-password-step-3",
    }

    $(document).on("submit", el.form3, function (e) {
      e.preventDefault();
      $('body').addClass('mi-loading')
      // const button = $(this).find('button[type="submit"]')
      const email = $('.email_step2').val()
      const password_1 = $(this).find('#password_1').val()
      const password_2 = $(this).find('#password_2').val()
      const url = $(this).find('input[name=wc_url_my_account]').val()

      if (password_1 === password_2) {
        __ajax($(this), {
          email: email,
          password: password_2
        }).then(() => {
          $(el.tab3).attr("open", false);
          $('#popup-notification-new_password_set').addClass('active');
        }).catch(() => {
          $('#popup-notification-email_not_found').addClass('active');
        })
      } else {
        $('#popup-notification-password_not_match').addClass('active');
      }

      $('body').removeClass('mi-loading')

      $('#popup-notification-new_password_set .js-toggle-class').on('click', function () {
        window.location.href = url;
      })
    });

  }

  init();
};

try {
  forgetPassword();
} catch (error) {
  console.error("forgetPassword: ", error);
}
